module.exports = __webpack_public_path__ + "static/img/RS.1b33bb26.png";